<template>
  <div class="activity-page">
    <!-- 活動已關閉遮罩 -->
    <div v-if="webStartOr === 0" class="web-start-or">
      <div class="web-alert">
        <img src="../assets/jinggao.png" alt="" />
        <span>活動報名已關閉！</span>
      </div>
    </div>

    <!-- 警告提示（用 Element Message，不需要自定義彈窗） -->

    <div class="container-fluid" v-if="!pageLoading">
      <div class="row header">
        <div class="col-md-2 col-sm-2"></div>
        <main class="col-md-8 col-sm-8">
          <h2 class="title">{{ activity.name }}</h2>

          <!-- 活動信息 -->
          <div class="per">
            <div class="form-group">
              <label class="control-label active-title">活動類型：</label>
              <div class="active-con active-time">{{ activity.typeName }}</div>
            </div>
            <div class="form-group">
              <label class="control-label active-title">費用：</label>
              <div class="active-con active-time">{{ activity.charge }}</div>
            </div>
            <div class="form-group">
              <label class="control-label active-title">地點：</label>
              <div class="active-con active-time">{{ activity.activityAddr || '無' }}</div>
            </div>
            <div class="form-group">
              <label class="control-label active-title">活動時間：</label>
              <div class="active-con active-time">
                {{ (activity.startTime || '').substring(0, 16) }} 到 {{ (activity.endTime || '').substring(0, 16) }}
              </div>
            </div>
            <div class="form-group form-group-actTime">
              <label class="control-label active-title">報名時間：</label>
              <div class="active-con active-time">
                {{ (activity.signStartTime || '').substring(0, 16) }} 到 {{ (activity.signEndTime || '').substring(0, 16) }}
              </div>
            </div>
            <div class="form-group">
              <label class="control-label active-title">活動人數報名上限：</label>
              <div class="active-con">{{ activity.enrollmentUpperlimit }}</div>
            </div>
            <!-- 活動詳情 -->
            <div class="active-detail" v-if="activity.welfareDisplay">
              <h3><i class="info_icon"></i>活動詳情</h3>
              <div class="info" v-html="activity.welfareDisplay"></div>
            </div>
          </div>

          <!-- 報名信息 -->
          <div class="infor" id="sign-info" v-if="webStartOr !== 0">
            <h3><i class="info_icon"></i>填寫報名信息</h3>
            <!-- 注意事項 -->
            <div class="form-group limit-condition">
              <p>注意事項：</p>
              <ul>
                <li>* 為必填項</li>
                <li>姓名和英文名必填一項</li>
              </ul>
              <div class="conditions" v-if="hasLimitCondition">
                <ul class="participator-age" v-if="activity.limit_age_end">
                  <li>僅限 {{ activity.limit_age_start }} ~ {{ activity.limit_age_end }} 歲人員參與</li>
                </ul>
                <ul class="participator-addredd" v-if="addressLimitList.length">
                  <li v-for="(a, i) in addressLimitList" :key="i">
                    僅限 {{ a.region_name }}{{ a.central_district_name }}{{ a.xq_name }}{{ a.street }}{{ a.edifice }} 的居民參與
                  </li>
                </ul>
                <ul class="participator-member" v-if="activity.isMember">
                  <li>僅限 會員 參與</li>
                </ul>
              </div>
            </div>

            <!-- type=1：舊版靜態表單（element 組件） -->
            <template v-if="activityType === 1">
              <div class="field-item" style="margin-top:16px;">
                <div class="field-label">姓名</div>
                <div class="field-control">
                  <el-input v-model="form1.name" placeholder="輸入您的姓名" :maxlength="20" clearable />
                </div>
              </div>
              <div class="field-item">
                <div class="field-label">手提電話<i class="impor">*</i></div>
                <div class="field-control">
                  <el-input
                    v-model="form1.mobile"
                    placeholder="輸入手提電話"
                    :maxlength="20"
                    clearable
                    @input="form1.mobile = form1.mobile.replace(/[^\d+]/g, '')"
                  />
                </div>
              </div>
              <div class="field-item">
                <div class="field-label">住址</div>
                <div class="field-control">
                  <el-input v-model="form1.address" placeholder="輸入地址" clearable />
                </div>
              </div>
              <div class="field-item">
                <div class="field-label">性別</div>
                <div class="field-control">
                  <el-radio-group v-model="form1.sex">
                    <el-radio label="男">男</el-radio>
                    <el-radio label="女">女</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </template>

            <!-- type=2：動態表單 -->
            <template v-if="activityType === 2">
              <DynamicForm
                ref="dynamicForm"
                :fields="selectedField"
              />
            </template>

            <!-- 報名按鈕 -->
            <div class="Signup">
              <el-button
                type="primary"
                :loading="submitting"
                size="medium"
                style="width:100%;"
                @click="handleSubmit"
              >
                {{ submitting ? '提交中...' : '報名' }}
              </el-button>
            </div>
          </div>
        </main>
        <div class="col-md-2 col-sm-2"></div>
      </div>
    </div>

    <!-- 載入中 -->
    <div v-if="pageLoading" class="page-loading">
      <i class="el-icon-loading"></i> 載入中...
    </div>

    <!-- 報名錨點 -->
    <div class="sign-immediately" @click="scrollToForm">
      <b>即刻報名</b>
    </div>
  </div>
</template>

<script>
import { getSimpleSign, simpleWebSign, addActivitySignWebNew } from '@/api/activity'
import DynamicForm from '@/components/DynamicForm.vue'

export default {
  name: 'ActivityPage',
  components: { DynamicForm },
  data () {
    return {
      pageLoading: true,
      submitting: false,
      activityId: null,
      activityType: 2,  // URL 的 type 參數
      activity: {},     // getSimpleSign 返回的 data
      selectedField: [], // type=2 欄位配置
      webStartOr: 1,
      addressLimitList: [],
      // type=1 表單數據
      form1: { name: '', mobile: '', address: '', sex: '' }
    }
  },
  computed: {
    hasLimitCondition () {
      return this.activity.limit_age_end || this.addressLimitList.length || this.activity.isMember
    }
  },
  created () {
    this.parseUrlParams()
    this.fetchActivity()
    this.bindAnchorScroll()
  },
  methods: {
    // 解析 URL 參數（兼容 ?id=xxx&type=2 和 ?v=2xxxxxx 兩種格式）
    parseUrlParams () {
      const params = new URLSearchParams(window.location.search)
      const v = params.get('v')
      if (v) {
        this.activityType = Number(v.substring(0, 1)) || 2
        this.activityId = v.substring(2)
      } else {
        this.activityType = Number(params.get('type')) || 2
        this.activityId = Number(params.get('id')) || null
      }
    },

    // 拉取活動信息
    async fetchActivity () {
      this.pageLoading = true
      try {
        const res = await getSimpleSign(this.activityId)
        if (res.code !== 200) {
          this.$message.error(res.message || '獲取活動信息失敗')
          return
        }
        const data = res.data
        this.activity = data
        this.webStartOr = data.webStartOr

        // 解析地址限制
        if (data.limit_address) {
          try { this.addressLimitList = JSON.parse(data.limit_address) } catch (e) { this.addressLimitList = [] }
        }

        // type=2 解析 selected_field（歸一化舊格式）
        if (this.activityType === 2 && data.selected_field) {
          const raw = Array.isArray(data.selected_field) ? data.selected_field : []
          this.selectedField = this.normalizeFields(raw)
        }
      } catch (e) {
        this.$message.error('網絡異常，請重試')
      } finally {
        this.pageLoading = false
      }
    },

    // 歸一化 selected_field：把舊版簡化格式補齊為新版結構
    // 舊版項目只有 fill_status/label/show_status/value，缺少 class 等，
    // 這裡依 value 推斷 class/type/data/maxlength/prompt，讓 DynamicForm 能渲染。
    normalizeFields (fields) {
      if (!Array.isArray(fields)) return []
      // value → 舊版欄位補齊配置
      const LEGACY = {
        sex:         { class: 'radio', type: 0, data: ['男', '女'], prompt: '請選擇性別' },
        birth:       { class: 'birth', type: 0 },
        area:        { class: 'area', type: 0, prompt: '請選擇大中小區' },
        phone:       { class: 'text', type: 0, maxlength: 8, prompt: '請輸入住宅電話' },
        identityNum: { class: 'text', type: 0, maxlength: 300, prompt: '請輸入身份證號碼' },
        address:     { class: 'text', type: 0, maxlength: 65, prompt: '請輸入詳細地址' },
        street:      { class: 'text', type: 0, maxlength: 300 },
        county:      { class: 'text', type: 0, maxlength: 300 },
        edifice:     { class: 'text', type: 0, maxlength: 300 },
        tower:       { class: 'text', type: 0, maxlength: 300 },
        unit:        { class: 'text', type: 0, maxlength: 300 },
        remark:      { class: 'text', type: 0, maxlength: 300 },
        remark1:     { class: 'text', type: 0, maxlength: 300 },
        remark2:     { class: 'text', type: 0, maxlength: 300 },
        remark3:     { class: 'text', type: 0, maxlength: 300 }
      }

      // 舊活動（欄位無 class）後端不返回姓名/英文名/手提電話，補到頭部（必顯示）。
      // 新活動欄位都有 class，按接口返回的 selected_field 原樣渲染，不補任何欄位。
      // 姓名、英文名均設 fill_status:0 —— 由 submitType2 交叉校驗「兩者必填其一」，
      // 避免在此被當作各自必填；手提電話為必填。
      const isLegacy = fields.length > 0 && fields.every(f => !f.class)
      const hasValue = v => fields.some(f => f && f.value === v)
      const head = []
      if (isLegacy) {
        if (!hasValue('name_zh')) {
          head.push({ value: 'name_zh', label: '姓名', class: 'text', type: 0, fill_status: 0, show_status: 1, maxlength: 50, prompt: '請輸入姓名' })
        }
        if (!hasValue('name_en')) {
          head.push({ value: 'name_en', label: '英文名', class: 'text', type: 0, fill_status: 0, show_status: 1, maxlength: 50, prompt: '請輸入英文名' })
        }
        if (!hasValue('mobile')) {
          head.push({ value: 'mobile', label: '手提電話', class: 'text', type: 0, fill_status: 1, show_status: 1, maxlength: 11, prompt: '請輸入手提電話' })
        }
      }

      const list = head.concat(fields.map(f => {
        if (!f) return f
        // 新版已有 class，原樣返回
        if (f.class) return f
        const cfg = LEGACY[f.value]
        if (cfg) {
          return Object.assign({
            value: f.value,
            label: f.label,
            fill_status: f.fill_status || 0,
            show_status: f.show_status || 0
          }, cfg, { prompt: cfg.prompt || (f.label ? `請輸入${f.label}` : '') })
        }
        // 未知 value 兜底為 text
        return Object.assign({
          value: f.value,
          label: f.label,
          fill_status: f.fill_status || 0,
          show_status: f.show_status || 0,
          class: 'text',
          type: 0,
          maxlength: 200,
          prompt: f.label ? `請輸入${f.label}` : ''
        })
      }))

      // 只渲染 show_status===1 的欄位：
      // 舊活動後端固定返回完整欄位集，用 show_status 控制是否顯示；
      // 新活動動態返回、show_status 全為 1，過濾無影響。
      return list.filter(f => f && f.show_status === 1)
    },

    // 報名按鈕
    async handleSubmit () {
      if (this.submitting) return
      this.submitting = true
      try {
        if (this.activityType === 1) {
          await this.submitType1()
        } else {
          await this.submitType2()
        }
      } finally {
        this.submitting = false
      }
    },

    // 1.0 報名
    async submitType1 () {
      const { name, mobile } = this.form1
      if (!name || !mobile) {
        this.$message.warning('信息輸入不全，請檢查！')
        return
      }
      const res = await addActivitySignWebNew({
        name,
        mobile,
        address: this.form1.address,
        ref_activity_id: this.activityId,
        sex: this.form1.sex
      })
      if (res.code === 200) {
        this.$message({ message: '登記完成！有關資料稍後會專人核對。', type: 'success', duration: 5000 })
        setTimeout(() => { this.form1 = { name: '', mobile: '', address: '', sex: '' } }, 5500)
      } else {
        this.$message.warning(res.message)
      }
    },

    // 2.0 報名
    async submitType2 () {
      const form = this.$refs.dynamicForm
      if (!form) return

      // 1. 校驗
      const errMsg = form.validate()
      if (errMsg) { this.$message.warning(errMsg); return }

      // 2. 收值
      const { params, customData } = form.collectValue()

      // 3. 姓名/英文名至少一個
      const hasNameZh = this.selectedField.some(f => f.value === 'name_zh')
      const hasNameEn = this.selectedField.some(f => f.value === 'name_en')
      if ((hasNameZh || hasNameEn) && !params.name_zh && !params.name_en) {
        this.$message.warning('請輸入姓名或者英文名！')
        return
      }

      // 4. 序列化自定義欄位
      params.activityId = ''
      params.webActivityId = this.activityId
      params.data = JSON.stringify(customData)

      // 5. 提交
      const res = await simpleWebSign(params)
      if (res.code === 200) {
        this.$message({ message: '登記完成！有關資料稍後會專人核對。', type: 'success', duration: 5000 })
        setTimeout(() => { form.reset() }, 5500)
      } else {
        this.$message.warning(res.message)
      }
    },

    scrollToForm () {
      const el = document.getElementById('sign-info')
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    bindAnchorScroll () {
      window.addEventListener('scroll', () => {
        const anchor = document.querySelector('.sign-immediately')
        if (!anchor) return
        anchor.style.display = window.scrollY < 350 ? 'block' : 'none'
      })
    }
  }
}
</script>

<style scoped>
.page-loading {
  text-align: center;
  padding: 80px 0;
  font-size: 18px;
  color: #999;
}
.web-start-or {
  display: flex;
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.4);
}
.web-alert {
  background: #fdf6ec;
  border-radius: 5px;
  padding: 30px 40px;
  color: #e6a23c;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}
.sign-immediately {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #188AFF;
  color: #fff;
  padding: 10px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,.2);
}
</style>
